export function request() {
    return {
        type: 'ROLE_GET_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'ROLE_GET_ERROR',
        errors
    };
}

export function finish(roles) {
    return {
        type: 'ROLE_GET_FINISH',
        roles
    };
}
